<template>
  <div class="px-4 pt-3 pb-1.5 flex items-center gap-1.5">
    <slot name="icon" />
    <p
      class="font-medium"
      :class="mixedCase ? 'text-[13px] font-semibold tracking-tight text-foreground' : 'text-[13px] text-muted-foreground'"
    >
      <slot />
    </p>
    <slot name="action" />
  </div>
</template>

<script setup lang="ts">
// mixedCase: обычный регистр без принудительного uppercase - для заголовков,
// где важен регистр букв (например, хэштег "#ПриветEcoway").
defineProps<{ mixedCase?: boolean }>();
</script>
